import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const remittanceData = (body: any) => {
  return {
    user: {
      mobile: {
        mobileNumber: body?.mobile ?? '',
        countryCode: '91',
      },
    },
    remittanceUserId: body?.remittanceUserId ?? '',
  }
}

export const fetchRemittanceCustomerDetailsApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    apiPath: APIEndPoints.fetchRemittanceUser,
    method: 'POST',
    config: config,
    body: remittanceData(body),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })

  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
